export default __webpack_public_path__ + "static/media/DSC_0551.0930c443.jpg";